import { Field, Form, FormikProps } from 'formik';
import { FormValues } from './types';
import styles from './ReportModal.module.css';
import DriverField from '../Forms/Fields/Driver';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';
import { FormikRadioGroupInput } from '../Forms/Components/RadioGroup';

type ReportFormProps = FormikProps<FormValues> & {
	id: string;
};

export default function DriverManifestForm({ id }: ReportFormProps) {
	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<Field
					name='reportDateRange'
					component={FormikDateRangePicker}
					label='Date Range'
					className={styles['date-range-input']}
				/>
				<DriverField
					fieldName='assignedDriver'
					className={styles['driver-dropdown']}
					mode={{
						Drivers: {
							enabled: true,
							itemOptions: {
								allowAll: true
							}
						},
						Tractors: {
							enabled: false
						},
						Carriers: {
							enabled: false
						},
						Salespeople: {
							enabled: false
						},
						requiresHazmat: false,
						driverOnly: true
					}}
					disabled={false}
					clearable={true}
				/>
			</div>
			<div>
				<div className={styles['flex-row']}>
					<Field
						component={FormikRadioGroupInput}
						name='accept'
						label='Report Format:'
						labelPlacement='top'
						defaultOptionSelected='HTML'
						radioItems={['HTML', 'Excel']}
					/>
				</div>
			</div>
		</Form>
	);
}
